import { render, staticRenderFns } from "./BrandSection.vue?vue&type=template&id=23845b0c&scoped=true"
import script from "./BrandSection.vue?vue&type=script&lang=ts"
export * from "./BrandSection.vue?vue&type=script&lang=ts"
import style0 from "./BrandSection.vue?vue&type=style&index=0&id=23845b0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23845b0c",
  null
  
)

export default component.exports